export const SHOPPING_BAG_BUTTON_PREFIX = "ShoppingBagButton";

export const SHOPPING_BAG_BUTTON_CLASSES = {
  root: `${SHOPPING_BAG_BUTTON_PREFIX}-root`,
  counter: `${SHOPPING_BAG_BUTTON_PREFIX}-counter`,
  popup: `${SHOPPING_BAG_BUTTON_PREFIX}-popup`,
};
